// @material-ui/icons
import Settlement from "@material-ui/icons/Style";
import Reconciliation from "@material-ui/icons/RestorePage";
import Audit from "@material-ui/icons/TrackChanges";
import Landing from "@material-ui/icons/FlightLandOutlined";

import MainLandingPage from "../layouts/Landing/RegionalLanding/landing";

import SettlementPage from "views/Settlement/Index.jsx";
import NotFound from "views/NotFound/Index.jsx";
import StatementOfAccount from "views/StatementOfAccount/Index.jsx"
import Audits from "views/AuditTrail/Index.jsx";
import HelpIcon from "@material-ui/icons/HelpOutline"
import HelpCenter from "../views/HelpCenter";

const dashboardRoutes = [
    {
        path: "/main-landing",
        sidebarName: "Main Landing",
        navbarName: "Main Landing",
        icon: Landing,
        component: MainLandingPage,
        subMenu: [],
    },
    {
        path: "/app/psc-settlement",
        sidebarName: " PSC Settlement",
        navbarName: "PSC Settlement",
        icon: Settlement,
        subMenu: [],
        component: SettlementPage
    },
    {
        path: "/app/statement-of-account",
        sidebarName: "Account Statement",
        navbarName: "Account Statement",
        icon: Reconciliation,
        component: StatementOfAccount,
        subMenu: []
    },
    {
        path: "/app/audits",
        sidebarName: "Audit Trail",
        navbarName: "Audit Trail",
        icon: Audit,
        subMenu: [],
        component: Audits,
    },
    {
        path: "/app/help-center",
        sidebarName: "Help Center",
        navbarName: "Help Center",
        icon: HelpIcon,
        component: HelpCenter,
        subMenu: []
      },
    {
        isNotVisible: true,
        path: "**",
        sidebarName: "Not found",
        navbarName: "Not Found",
        icon: Audit,
        subMenu: [],
        component: NotFound,

    }
];

export default dashboardRoutes;



// WEBPACK FOOTER //
// ./src/routes/audit.jsx